import { create } from 'zustand';

import { IPolicyModalState } from './interfaces';

const initialState = {
  open: false,
  pdfContent: [],
};

export const usePolicyState = create<IPolicyModalState>((set) => ({
  ...initialState,
  setOpen: (open) => set({ open }),
  setPdfContent: (pdfContent: string[]) => set({ pdfContent }),
}));
